export function isEmptyObject(obj: object | null): boolean {
  return obj == null || (Object.keys(obj).length === 0);
}

export function isEmoji(emoji: string | null): boolean {
  //const emojiRegex = /\p{Emoji}/u;
  const emojiRegex = /\p{Extended_Pictographic}/u;
  return emoji != null && emojiRegex.test(emoji);
}

export function generateUniqueId(): string {
  return 'key-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
}

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
export function shuffleArray(array: any[]): any[] {
  const copyArray = array.map(a => a);
  for (let i = copyArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copyArray[i], copyArray[j]] = [copyArray[j], copyArray[i]];
  }
  return copyArray;
}

export function sortFn<T>(sortProp: keyof T, asc = true, type: 'text' | 'number' = 'text'): (a: T, b: T) => number {
  const collator = new Intl.Collator();

  if (type === 'text') {
    return asc ? (a: any, b: any) => collator.compare(a[sortProp], b[sortProp])
      : (a: any, b: any) => collator.compare(b[sortProp], a[sortProp]);
  } else {
    return asc ? (a: any, b: any) => a[sortProp] - b[sortProp] : (a: any, b: any) => b[sortProp] - a[sortProp];
  }
}



